/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

export const createPurchaseOrderRpc = {
  serviceName: 'com.hubspot.monetization.rpc.PurchaseChirpService',
  rpcName: 'createPurchaseOrder',
  auth: 'app',
  fingerprint: '2S56cXfw33RnmoH1_3JNaBEOGDRJSanM'
};